// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientModel {
    static getAttributeTypeMap() {
        return PatientModel.attributeTypeMap;
    }
}
PatientModel.discriminator = undefined;
PatientModel.additionalProperties = false;
PatientModel.attributeTypeMap = [
    {
        "name": "patientId",
        "baseName": "patientId",
        "type": "string"
    },
    {
        "name": "isDuplicate",
        "baseName": "isDuplicate",
        "type": "boolean"
    },
    {
        "name": "isTest",
        "baseName": "isTest",
        "type": "boolean"
    },
    {
        "name": "isPlaceholder",
        "baseName": "isPlaceholder",
        "type": "boolean"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": ""
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": ""
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": ""
    },
    {
        "name": "globalIds",
        "baseName": "globalIds",
        "type": ""
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
    {
        "name": "suffix",
        "baseName": "suffix",
        "type": "string"
    },
    {
        "name": "nickname",
        "baseName": "nickname",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "Date"
    },
    {
        "name": "primaryLanguageId",
        "baseName": "primaryLanguageId",
        "type": "number"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "Gender"
    },
    {
        "name": "isUsResident",
        "baseName": "isUsResident",
        "type": "boolean"
    },
    {
        "name": "householdSize",
        "baseName": "householdSize",
        "type": "number"
    },
    {
        "name": "masterPatientId",
        "baseName": "masterPatientId",
        "type": "string"
    },
    {
        "name": "raceCode",
        "baseName": "raceCode",
        "type": "string"
    },
    {
        "name": "ethnicityCode",
        "baseName": "ethnicityCode",
        "type": "string"
    },
    {
        "name": "unsecureMasterPatientId",
        "baseName": "unsecureMasterPatientId",
        "type": "number"
    },
];
//# sourceMappingURL=patientModel.js.map